<route>
{
  "name": "index",
  "meta": {
    "order": 1,
    "isVisible": true,
    "iconName": "mdi-home"
  }
}
</route>

<template>
  <div>
    <page-title
      :title="$t('pages.dashboard.title')">
      <v-btn
        class="mb-3"
        @click="preLoad">
        <v-icon
          class="ml-3">
          mdi-reload
        </v-icon>
        {{ $t('buttons.reload') }}
      </v-btn>
    </page-title>

    <v-row
      v-if="!pageDataIsReady"
      >
      <v-col
        v-for="i in [0, 1, 2, 3, 4, 5]"
        cols="12"
        md="2"
        >
        <v-skeleton-loader
          max-height="140"
          type="card"
          ></v-skeleton-loader>
      </v-col>
        <v-col
          cols="12">
          <v-skeleton-loader
            type="card"
            ></v-skeleton-loader>
        </v-col>
    </v-row>


    <v-row 
      v-if="pageDataIsReady"
      dense>
      <v-col 
           v-for="value, key in statistics"
           col="12"
           :md="key == 'courses' ? 4 : 2">
        <v-card
          color="#5d6486"
          raised
          ripple
          outline
          dark
          >
          <v-card-title class="headline">
            {{ value }}
          </v-card-title>

          <v-card-subtitle
            class="mt-5">
            {{ $t(`pages.${key}.title`) }}
          </v-card-subtitle>

          <!--<v-card-actions>-->
          <!--<v-btn -->
          <!--:to="{ name: 'courses'}"-->
          <!--text>-->
          <!--{{ $t('buttons.more') }}-->
          <!--</v-btn>-->
          <!--</v-card-actions>-->
        </v-card>
      </v-col>
    </v-row>
    <v-card 
      v-if="pageDataIsReady"
      class="mt-4">
      <highcharts :options="chartOptions"></highcharts>
    </v-card>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import PersianDate from 'persian-date'
export default {
  name: 'pageHome',
  layout: APP_CONFIG.layout.mainPanelLayout,
  data () {
    return {
      statistics: {},
      answers: [],
      pageDataIsReady: false,
      pageLoading: false,
      chartOptions: {
        chart: {
          height: this.chartHeight,
          padding: 0,
          type: 'area'
        },

        title: {
          // text: this.$t('statistics.seven_days_report')
          text: ''
        },

        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
          xDateFormat: '%A, %b %e, %H:%M'
        },

        yAxis: {
          title: {
            enabled: false,
            text: this.$t('models.answers')
          },
          labels: {
            enabled: false
          },
          gridLineWidth: 0
        },

        time: {
          useUTC: false
        },

        xAxis: {
          type: 'datetime',
          tickmarkPlacement: 'on',
          gridLineWidth: 1,
          tickWidth: 0,
          tickInterval: 1 * 24 * 3600 * 1000,
          labels: {
            formatter: function () {
              return Highcharts.dateFormat('%e-%b', this.value)
            }
          }
        },

        legend: {
          enabled: true,
          layout: 'horizontal'
        },

        plotOptions: {
          area: {
            stacking: 'percent',
            lineColor: '#ffffff',
            lineWidth: 1
          }
        },

        series: [],

        credits: {
          enabled: false
        }
      }
    }
  },
  created () {
    this.preLoad()
  },
  methods: {
    setSeies () {
      const self = this
      this.chartOptions.series = [
        {
          type: 'line',
          type: self.chartOptions.chart.type,
          name: this.$t('statistics.members'),
          data: this.answers.map(item => [new PersianDate(new Date(item.date)).startOf('days').valueOf(), item.members])
        },    
        {
          type: self.chartOptions.chart.type,
          color: '#5d6486',
          name: this.$t('statistics.total_answers'),
          data: this.answers.map(item => [new PersianDate(new Date(item.date)).startOf('days').valueOf(), item.total])
        },
        {
          type: self.chartOptions.chart.type,
          color: '#518B69',
          name: this.$t('statistics.correct_answers'),
          data: this.answers.map(item => [new PersianDate(new Date(item.date)).startOf('days').valueOf(), item.corrects])
        },
        {
          type: self.chartOptions.chart.type,
          color: '#FF3B30',
          name: this.$t('statistics.incorrect_answers'),
          data: this.answers.map(item => [new PersianDate(new Date(item.date)).startOf('days').valueOf(), item.incorrects])
        }
      ]
    },
    preLoad () {
      this.pageLoading = true
      this.$store.dispatch('statistic/getStatistics').then((response) => {
        this.statistics = response.data
        this.$store.dispatch('statistic/getDailyAnswers').then((response) => {
          this.answers = response.data
          this.setSeies()   
          this.pageLoading = false
          this.pageDataIsReady = true
        })
      })
    }
  }
}
</script>
